import { defineMessages } from 'react-intl'

export default defineMessages({
  newToolbar: {
    id: 'OrganizationToolbarsPage.AddEditModal.NewToolbar',
    defaultMessage: 'Add Client'
  },
  editToolbar: {
    id: 'OrganizationToolbarsPage.AddEditModal.EditToolbar',
    defaultMessage: 'Edit Client'
  },
  modalRequired: {
    id: 'OrganizationToolbarsPage.AddEditModal.ModalRequired',
    defaultMessage: '(all fields are required)'
  },
  toolbarName: {
    id: 'OrganizationToolbarsPage.AddEditModal.ToolbarName',
    defaultMessage: 'Name your client'
  },
  toolbarNameRequired: {
    id: 'OrganizationToolbarsPage.AddEditModal.ToolbarNameRequired',
    defaultMessage: 'Client Name'
  },
  toolbarDesc: {
    id: 'OrganizationToolbarsPage.AddEditModal.Description',
    defaultMessage: 'Client Description'
  },
  toolbarDescRequired: {
    id: 'OrganizationToolbarsPage.AddEditModal.DescriptionRequired',
    defaultMessage: 'Client Description is a required field'
  },
  credentials: {
    id: 'OrganizationToolbarsPage.AddEditModal.Credentials',
    defaultMessage: 'Client Credentials'
  },
  clientId: {
    id: 'OrganizationToolbarsPage.AddEditModal.ClientId',
    defaultMessage: 'Client ID'
  },
  clientSecret: {
    id: 'OrganizationToolbarsPage.AddEditModal.ClientSecret',
    defaultMessage: 'Client Secret'
  },
  cancel: {
    id: 'SpaceFlowsPage.CreateTask.Cancel',
    defaultMessage: 'Cancel'
  },
  createAndClose: {
    id: 'SpaceFlowsPage.CreateTask.CreateAndClose',
    defaultMessage: 'Create & Close'
  },
  generateCredentials: {
    id: 'OrganizationToolbarsPage.AddEditModal.GenerateCredentials',
    defaultMessage: 'Generate Credentials'
  },
  updateAndClose: {
    id: 'SpaceFlowsPage.CreateTask.UpdateAndClose',
    defaultMessage: 'Update & Close'
  },
  onlyDisplayedOnce: {
    id: 'OrganizationToolbarsPage.AddEditModal.DisplayedOnce',
    defaultMessage: '(This will only be displayed once!)'
  },
  alreadyGenerated: {
    id: 'OrganizationToolbarsPage.AddEditModal.AlreadyGenerated',
    defaultMessage: 'Client secret has already been generated'
  }
})
